<template>
  <div
    class="form-group"
    :class="{ 'has-error': errors.has(validationName), 'form-group-active': active }"
  >
    <label class="control-label" v-if="label">{{ label }}</label>
    <multiselect
      :noOptions="messages.noOptions"
      ref="select"
      :value="value"
      :options="options"
      :multiple="true"
      :placeholder="placeholder"
      :showLabels="false"
      label="text"
      track-by="value"
      selectLabel="Pressione enter para selecionar"
      selectGroupLabel="Pressione enter para selecionar o grupo"
      deselectLabel="Pressione enter para remover"
      deselectGroupLabel="Pressione enter para remover o grupo"
      :data-vv-as="label"
      :disabled="disabled"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      @blur="changeFocus()"
      @focus="changeFocus()"
    >
      <span slot="noResult">{{messages.noResult}}</span>
      <span slot="maxElements">{{messages.maxElements}}</span>
      <span slot="noOptions">{{messages.noOptions}}</span>
    </multiselect>
    <error-message :message="errors.first(validationName)"></error-message>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  inject: ["$validator"],
  name: "form-group-search-select-multiple",
  components: {
    Multiselect
  },
  props: {
    label: String,
    id: String,
    name: String,
    scope: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    required: String,
    value: Array,
    options: Array
  },
  data() {
    return {
      active: false,
      messages: {
        noOptions: "Nenhuma opção disponível",
        noResult: "Nenhum registro encontrado",
        maxElements: `Número máximo opções selecionadas`
      }
    };
  },
  computed: {
    validationName() {
      return this.scope ? `${this.scope}.${this.name}` : this.name;
    }
  },
  mounted() {
    this.$el.value = this.value;
  },
  methods: {
    changeFocus() {
      this.active = !this.active;
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tags {
  border-radius: 3px !important;
  border: 1px solid #ccc !important;
  padding: 5px 40px 0 8px !important;
}
.multiselect__option--highlight {
  background: rgba(108, 117, 125, 0.1) !important;
  color: #35495e !important;
}
.multiselect__option--selected.multiselect__option--highlight {
  background: rgba(108, 117, 125, 0.1) !important;
  color: #35495e !important;
}

.multiselect__tag {
  background: gray !important;
}

.multiselect__tag-icon:hover {
  background: red !important;
  color: black !important;
}

.multiselect__tag-icon:after {
  content: "\D7" !important;
  color: #fff !important;
  font-size: 14px !important;
}

.multiselect__option {
  font-size: 14px !important;
}

.multiselect__placeholder {
  font-size: 14px !important;
}

.multiselect__input,
.multiselect__single {
  margin-top: 3px !important;
  margin-bottom: 3px !important;
  font-size: 14px !important;
}

.has-error .multiselect__tags {
  border-color: #a94442 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormGroupSearchSelectMultiple.vue